import * as React from "react";
import { forwardRef } from "react";
const SvgClose = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1.266 0 0 1.266 7.734 9 0 16.734 1.266 18 9 10.266 16.734 18 18 16.734 10.266 9 18 1.266 16.734 0 9 7.734Z", className: "s9059af16d7120be179340fb741556265__b" }));
const ForwardRef = forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
